import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import ResultDetailCard from '@Components/Results/common/ResultDetailCard';

function DocumentIndexTerms({ keywords, closeClick }) {
  return (
    <ResultDetailCard id="indextermsExpanded-content" title="Index Terms" closeDataE2e="e2e-index-terms-close" onClose={closeClick}>
      <div className="u-els-font-size-base u-els-line-height-default">
        {keywords.map((keyword) => (
          <div key={keyword.type}>
            <b>{keyword.type}: </b>
            {keyword.value &&
              keyword.value?.map((value) => (
                <React.Fragment key={value}>
                  <InnerHTML tag="span" html={value} />
                  {keyword.value?.indexOf(value) !== keyword.value.length - 1 && <span className="separator" />}
                </React.Fragment>
              ))}
          </div>
        ))}
      </div>
    </ResultDetailCard>
  );
}

DocumentIndexTerms.propTypes = {
  keywords: PropTypes.array.isRequired,
  closeClick: PropTypes.func.isRequired,
};

export default DocumentIndexTerms;
